// extracted by mini-css-extract-plugin
export default {"formModal":"styles_formModal__yXpYE","title":"styles_title__Whjj5"};